module.exports = __webpack_public_path__ + "static/media/headline.5743e064.jpg";